(function () {
	const init = () => {
		document.addEventListener('click', function(e){
			const target = e.target;

			if(target.closest('[data-nav-close]')){
				close();
				return;
			}

			if(target.closest('[data-nav-open]')){
				open(e, target.closest('[data-nav-open]'));
				return;
			}

			if(target.closest('[data-nav-back]')){
				back();
				return;
			}

			if(target.closest('[data-nav-next]')){
				next(target.closest('[data-nav-next]'));
				return;
			}
		});
	};

	function close(){
		document.body.classList.remove('overflow-hidden');
		const drawer = document.querySelector('.navigation-drawer');
		if(!drawer) return false;
		const overlay = drawer.querySelector('.navigation-drawer_overlay');
		if(overlay){
			overlay.classList.remove('_active');
		}
		setTimeout(()=>{
			drawer.classList.remove('_active');
			setTimeout(()=>{
				clear();
			}, 100)
		}, 100)

		return true;
	}

	function open(e, target){
		e.preventDefault();
		clear();

		document.body.classList.add('overflow-hidden');

		const handle = target.dataset.navOpen;
		if(handle){
			const handleBody = document.querySelector(`[data-nav-body="${handle}"]`);
			if(handleBody){
				next(handleBody);
			}
		}
		
		const drawer = document.querySelector('.navigation-drawer');
		if(!drawer) return false;
		drawer.classList.add('_active');
		const overlay = drawer.querySelector('.navigation-drawer_overlay');
		if(overlay){
			setTimeout(()=>{
				overlay.classList.add('_active');
			}, 200)
		}
		return true;
	}

	function clear() {
		window.navigation_drawer = [];
		document.querySelectorAll('[data-nav-body]').forEach((item)=>{
			item.classList.remove('_active');
		})
	}

	function back(){
		const lastMenu = window.navigation_drawer.pop();
		if(lastMenu){
			fixScroll();
			lastMenu.classList.remove('_active');
		}
	}

	function next(item){
		const wrapper = item.closest('[data-nav-wrapper]');
		if(!wrapper) return false;

		const body = wrapper.querySelector('[data-nav-body]');
		if(!body) return false;

		if(!window.navigation_drawer) window.navigation_drawer = [];
		window.navigation_drawer.push(body);
		fixScroll();
		body.classList.add('_active');
		
		return true;
	}

	function fixScroll(){
		const allbodys = document.querySelectorAll('[data-nav-body]');
		allbodys.forEach(body => {
			body.scrollTop = 0;
		})
	}

	document.addEventListener("shopify:section:load", function () {
		init();
	});

	init();
})();
